
import { Component, Prop, Vue, Watch, Emit } from "vue-property-decorator";
import Editor5 from "@/components/editor/classic-editor5.vue";
import UploadImg from "@/components/UploadImg-ai.vue";
import UploadVideo from "@/components/UploadVideo-ai.vue";
import draggable from "vuedraggable";
import RegisEdit from "../components/regis-edit.vue";
import Pop from "../components/blue-pop.vue";
import ExamList from "@/lib/model/exam/exam";
import Loading from "../../../components/loading.vue";

import {
  ExamV2Custom,
  RegisInfo,
  Param
} from "@/lib/model/exambuilder/exam-v2";

import { ExamV3, HeaderOption } from "@/lib/model/workerbuilder/exam-v3";
import Auth from "@/lib/common/auth";

class TestExamList {
  id = 0;
  name = "";
  connectCode = "";
}

@Component({
  components: {
    Editor5,
    UploadImg,
    draggable,
    RegisEdit,
    UploadVideo,
    Pop,
    Loading
  }
})
export default class SetOther extends Vue {
  @Prop({ type: ExamV3, default: null }) exam!: ExamV3; //考试Model
  @Prop({ type: Boolean, default: false }) isEdit!: boolean; //是否编辑页面
  @Prop({ type: Boolean, default: false }) isCandidateUsed!: boolean; //是否已有人作答
  @Prop({}) companyPower!: any; //公司权限

  @Watch("exam", { deep: true })
  save(n: any, o: any) {
    //编辑时 数据加载完成后刷一次
    if (this.isEdit && !o.isAssigned && n.isAssigned) {
      this.setData();
      return;
    }
    this.change();
  }
  //切限制次数
  @Watch("repeatLimit", {})
  rp(n: any, o: any) {
    //不限制
    if (!n) {
      this.exam.repeatAnswerLimit = 100;
      // this.repeatLimitShow = 1;
    } else {
      //限制
      this.exam.repeatAnswerLimit = this.repeatLimitShow;
    }
  }
  //   // 防作弊开启关闭赋默认值
  //   setCheat(value: number) {
  //   if (value === 1) {
  //     // 开启
  //     this.exam.screenshotCheck = this.exam.mobileJoinCountCheck = 1;
  //     this.exam.screenshotCheckLimit = this.exam.mobileJoinCountCheckLimit = 2;
  //   } else {
  //     this.exam.screenshotCheck = this.exam.mobileJoinCountCheck = 2;
  //     this.exam.screenshotCheckLimit = this.exam.mobileJoinCountCheckLimit = 0;
  //   }
  // }
  //模拟练习开关
  @Watch("useTestExam", {})
  te(n: any, o: any) {
    if (n) {
      //开
      this.exam.testExamId = this.exam.testExamId
        ? this.exam.testExamId
        : this.testExamList?.[0]?.id;
    } else {
      this.exam.testExamId = 0;
    }
  }
  //身份证后六位 固定在第三项
  id6AtThird(n: Param[], o: any) {
    const i = n.findIndex(d => d.inputType === "shortIdCard");
    if (i !== -1) {
      const item = this.RegisSelectedList[i];
      this.RegisSelectedList.splice(i, 1);
      this.RegisSelectedList.splice(2, 0, item);
    }
  }

  //封面图片 用哪个
  // @Watch("useDiyImg", { deep: true })
  imgChange(n: any) {
    if (n === 0) {
      this.exam.publicityPageVideoCoverUrl = this.defaultBG;
    } else {
      this.exam.publicityPageVideoCoverUrl = this.upImgUrl;
    }
    this.change();
  }
  //视频 用哪个
  // @Watch("exam.publicityPageVideoUseWhich", { deep: true })
  videoChange(n: any) {
    if (n === 1) {
      //默认
      this.exam.publicityPageVideoUrl = this.videoUrlDef;
    }
    if (n === 2) {
      //自定义
      this.exam.publicityPageVideoUrl = this.videoUrl;
    }
    this.change();
  }
  //切换限制时间
  changTimeLimit(n: any) {
    if (n === 1) {
      //24h
      this.exam.timeLimitExam = 0;
      // this.timeLimitExam = 0;
    } else {
      //自定义分钟数
    }
  }
  //限制次数的时间区间
  @Watch("exam.repeatAnswerDayLimit", { deep: true, immediate: true })
  timeLimitRule(n: any, o: any) {
    console.log(n);
    if (n) {
      this.exam.repeatAnswerDayLimit =
        Number(n) < 1 ? 1 : Number(n) > 365 ? 365 : Number(n);
    }
  }
  defaultBG =
    "https://oss.hina.com/app/hina/2021/07/10/3f1396a2ddd6a8493c582f22c69dae39.png";
  radio1 = 0;
  radio2 = 1;
  timeArr: string[] = [];
  ttt = "";
  upImgUrl = "";
  useDiyImg = 0; //使用默认图片封面
  RegisList: Param[] = []; //所有字段list
  RegisSelectedList: Param[] = []; //已选字段list
  showRegis = false; //弹窗 -字段
  editParam: any; //编辑体
  videoUrl = ""; //视频预览url
  videoUrlDef =
    "https://vod.hina.com/a3309d04251940faa56806be59bdf122/8c7be05066f64d29ae74ffbd5500daa9-ca173c7e0f3241eb8285dedda051a1ba-ld.mp4"; //视频预览url默认
  textDef1 =
    "海纳隶属于北京群星闪耀科技有限公司，致力于以AI技术赋能人力资源行业，帮助千千万万人才和企业做好人岗匹配、提升组织效率。拥有雄厚资本支持，可保证团队投入大量资金和人力到产品研发上，持续提升AI及产品能力，为大型集团提供可靠、持久的杰出服务。";
  textDef2 =
    "你好，我是本次面试的面试官，欢迎参加本公司的线上面试！面试预计需要10分钟，请你提前安排在网络良好、且相对安静的环境参加这次面试，以免因为网络等原因影响这次面试的结果。如果你在面试过程中遇到问题，请与我们的招聘人员联系。";
  textDef3 =
    "感谢你参加面试，面试结果我们会在1-3个工作日内通知你。我们期待你的加入，再见！";
  repeatLimit = false;
  repeatLimitShow = 1; //限制面试次数 下拉展示用
  useTestExam = 0; //模拟练习 开关
  // timeLimitExamType = 1; //考试时间限制类型
  // timeLimitExam = 0; //时长
  testExamList: TestExamList[] = [new TestExamList()];
  dataReady = false;

  usedMessage = false;

  startLoading() {
    this.dataReady = false;
  }
  //提交前校验
  checkData() {
    //非空
    if (
      this.exam.timeLimitExamType === 2 &&
      Number(this.exam.timeLimitExam) === 0
    ) {
      this.$message.warning("请输入答题时间限制");
      return false;
    }
    return true;
  }

  created() {
    //获取公司所有字段 初始值
    RegisInfo.getAll(Auth.companyId).then(res => {
      res.paramList.forEach((d: any) => {
        //新增时 选项存入个随机id
        for (let i = 0; i < d.singleChoiceOptions.length; i++) {
          d.fIdList.push(this.R());
        }
      });
      //首次直接扔缓存里，后续只与缓存io
      this.exam.paramList =
        this.exam.paramList.length > 1 ? this.exam.paramList : res.paramList;
      this.RegisList = this.exam.paramList; //全部
      this.checkHeaderOption(); //处理考察项中的登记字段
      //已选 排序
      this.RegisSelectedList = this.RegisList.filter(res => {
        return res.isShow === 1;
      }).sort((a: Param, b: Param) => {
        return Number(a.sort) - Number(b.sort);
      });
      this.change();
      this.dataReady = true;
    });
  }

  mounted() {
    //新建
    if (!this.isEdit) {
      //封面图片url 新建时初始化
      this.exam.publicityPageVideoCoverUrl =
        this.exam.publicityPageVideoCoverUrl || this.defaultBG;
      this.upImgUrl = this.exam.publicityPageVideoCoverUrl;
      //岗位描述 须知 结束 默认文案
      this.exam.publicityPageContent =
        this.exam.publicityPageContent || this.textDef1;
      this.exam.descBefore = this.exam.descBefore || this.textDef2;
      this.exam.descAfter = this.exam.descAfter || this.textDef3;
    } else {
      //编辑
    }
    this.setData();
  }

  //处理考察项关联
  checkHeaderOption() {
    //先把字段列表里的 是否为自定义考察项 都刷成 否
    this.RegisList.forEach((d: Param) => {
      if (d.isHeaderOption) {
        d.isHeaderOption = false;
        d.isShow = 0; //自定义的 先都刷成不使用
      }
    });
    //再检查所有考察项
    this.exam.headerOptions.forEach((d: HeaderOption, i: number) => {
      //自定义的单多选 需生成对应的登记信息字段
      if (["通用多选", "通用单选"].includes(d.type) && d.defaultMulti !== 1) {
        const hasIndex = this.RegisList.findIndex((p: Param) => {
          return p.name === d.param.name;
        });
        //是否有使用的选择题类型的配置项
        const usedFlag =
          (d.type === "通用单选" && d.useLevel !== 0) ||
          (d.type === "通用多选" &&
            d.paramUseRuleList.find((s: any) => {
              return s.useLevel !== 0;
            }));
        //模拟个新字段
        const p = new Param().assign(d.param);
        p.isHeaderOption = true;
        p.paramIndex = this.RegisList.length + 1;
        p.isShow = usedFlag ? 1 : 0; //是否使用
        p.isRequired = this.exam.headerOptions[i].param.isRequired; //必填
        p.showConfigList = []; //条件显示
        if (hasIndex === -1) {
          //未有  新建对应字段
          p.sort = this.RegisList.length + 100; //保证排序在最后
          this.RegisList.push(p);
        } else {
          //已有 则替换掉
          p.saveLater = this.RegisList[hasIndex].saveLater; //原样扔回
          p.sort = this.RegisList[hasIndex].sort; //保持排序
          this.RegisList.splice(hasIndex, 1, p);
          // this.RegisList[hasIndex].paramIndex = this.RegisList.length + 1;
          // this.RegisList[hasIndex].sort = this.RegisList.length + 100; //保证排序在最后

          // this.RegisList[hasIndex].showConfigList = [];
          // this.RegisList[hasIndex].isRequired =
          //   this.exam.headerOptions[i].param.isRequired; //必填

          // this.RegisList[hasIndex].isHeaderOption = true;
          // this.RegisList[hasIndex].isShow = usedFlag ? 1 : 0;
          // this.RegisList[hasIndex].isRequired = 1; //必填
        }
      }
    });
    //一些条件
    const usedIdCard = this.exam.headerOptions.find((d: HeaderOption) => {
      return (
        [
          "人脸识别",
          "手机号实名认证",
          "年龄要求",
          "负面社会安全记录",
          "金融黑名单"
        ].includes(d.type) && d.useLevel !== 0
      );
    });
    const ii = this.RegisList.findIndex((sf: Param) => {
      return sf.name === "身份证号";
    });
    if (ii === -1) return;
    // 前置必填身份号
    if (usedIdCard) {
      this.RegisList[ii].isShow = 1;
      this.RegisList[ii].isRequired = 1;
      this.RegisList[ii].isHeaderOption = true;
      // this.RegisList[ii].sort = 9999;
    } else {
      this.RegisList[ii].isHeaderOption = false;
    }
    //前置必选手机验证码
    this.usedMessage = Boolean(
      this.exam.headerOptions.find((d: HeaderOption) => {
        return (
          ["手机号实名认证", "负面社会安全记录", "金融黑名单"].includes(
            d.type
          ) && d.useLevel !== 0
        );
      })
    );
    if (this.usedMessage) {
      this.exam.captchaCheck = 1;
    }
    this.change();
  }
  //视频是否解码完成
  get videoReady() {
    return (
      this.exam.publicityPageVideoUseWhich === 2 &&
      this.exam.publicityPageVideoUrl
    );
  }
  get hasFacePower() {
    return this.companyPower.livenessRecognition === 1;
  }
  //计算长度
  get ww() {
    const t: any = this.testExamList.find(d => d.id === this.exam.testExamId);
    return (t?.name?.length ?? 5) * 14 + 55;
  }
  //选项ID生成
  R() {
    return String((Math.random() * 10000000000).toFixed(0));
  }

  //exam回显数据
  setData() {
    this.timeArr = [this.exam.beginTime, this.exam.endTime]; //编辑回显时间段
    //封面图片url
    this.exam.publicityPageVideoCoverUrl =
      this.exam.publicityPageVideoCoverUrl || this.defaultBG;
    this.upImgUrl = this.exam.publicityPageVideoCoverUrl;
    //封面图片是否diy
    this.useDiyImg =
      this.exam.publicityPageVideoCoverUrl === this.defaultBG ? 0 : 1;
    //自定义封面视频
    this.exam.publicityPageVideoUrl =
      this.exam.publicityPageVideoUseWhich === 2
        ? this.exam.publicityPageVideoUrl
        : "";
    this.exam.publicityPageVideoId =
      this.exam.publicityPageVideoUseWhich === 2
        ? this.exam.publicityPageVideoId
        : "";
    this.videoUrl = this.exam.publicityPageVideoUrl;
    //限制面试次数
    const isLimit = this.exam.repeatAnswerLimit !== 100;
    this.repeatLimit = isLimit ? true : false;
    this.repeatLimitShow = isLimit ? this.exam.repeatAnswerLimit : 1;
    //模拟练习
    this.useTestExam = this.exam.testExamId !== 0 ? 1 : 0;
    //答题时间限制
    // this.timeLimitExamType = this.exam.timeLimitExam === 86400 ? 1 : 2;
    this.exam.timeLimitExam =
      this.exam.timeLimitExam === 86400
        ? 0
        : this.isEdit
        ? this.exam.timeLimitExam / 60
        : this.exam.timeLimitExam; //默认 或 秒转分
    this.getTestExam(); //模拟练习
  }
  //时间段
  setTime(timelist: any) {
    this.exam.beginTime = timelist[0];
    this.exam.endTime = timelist[1];
    this.change();
  }
  //短信验证码
  setMessage() {
    if (this.usedMessage) return;
    this.exam.captchaCheck = this.exam.captchaCheck === 1 ? 2 : 1;
    this.change();
  }
  //已选字段排序sort
  sortSelected() {
    this.RegisSelectedList.forEach((d, i) => {
      d.sort = i + 1;
    });
    this.exam.paramList = this.RegisList;
    this.change();
  }
  //模拟练习
  getTestExam() {
    ExamList.getTestExams().then(res => {
      if (res.code === 0) {
        if (res.data.length) {
          this.testExamList = res.data;
          if (this.useTestExam) {
            this.exam.testExamId = this.exam.testExamId
              ? this.exam.testExamId
              : res.data?.[0]?.id;
          } else {
            this.exam.testExamId = 0;
          }
        }
      }
    });
  }
  //选择
  select(item: Param) {
    if (item.isHeaderOption) {
      this.$message.warning("已与考察项配置相关联，不可修改");
      return;
    }
    const i = this.RegisSelectedList.findIndex(
      (d: Param) => d.name === item.name
    );
    item.isShow = item.isShow === 1 ? 2 : 1;
    if (i !== -1) {
      //取消
      this.RegisSelectedList.splice(i, 1);
      this.$forceUpdate();
    } else {
      //选中
      if (item.inputType !== "shortIdCard") {
        this.RegisSelectedList.push(item);
        this.$forceUpdate();
      } else {
        //身份后六 固定第三
        this.RegisSelectedList.splice(2, 0, item);
        this.$forceUpdate();
      }
    }
    this.sortSelected();
  }
  //新增
  addRegis() {
    this.editParam = undefined;
    this.showRegis = true;
  }

  editRegis(item: Param) {
    this.editParam = item;
    this.showRegis = true;
  }
  //字段确认  params:更新后数据   edit:更新前数据
  editOk(params: Param, edit: any) {
    const n = this.RegisList.find(d => d.name === params.name);
    if (n && n?.paramIndex !== params.paramIndex) {
      this.$message.warning("字段名称不能重复");
      return;
    }
    if (edit) {
      //编辑
      this.RegisList.splice(Number(edit.paramIndex) - 1, 1, params);
      const i = this.RegisSelectedList.findIndex(
        d => d.paramIndex === edit.paramIndex
      );
      if (i !== -1) {
        this.RegisSelectedList.splice(i, 1, params);
      }
    } else {
      //新增
      params.paramIndex = this.RegisList.length + 1;
      params.isShow = 1;
      this.RegisList.push(params);
      // this.select(params)
      this.RegisSelectedList.push(params); //直接选中
      this.sortSelected();
    }
    this.exam.paramList = this.RegisList;

    this.change();
    this.showRegis = false;
  }
  editClose() {
    this.showRegis = false;
  }
  //人脸开启 跟随选中身份证字段
  setIdCard(e: any) {
    if (e !== 1) return;
    const i = this.RegisList.findIndex(d => d.name === "身份证号");
    if (i !== -1 && this.RegisList[i].isShow !== 1) {
      this.RegisList[i].isRequired = 1;
      this.select(this.RegisList[i]);
    }
  }

  //上传图片
  uploaded(d: any) {
    this.upImgUrl = d;
    this.exam.publicityPageVideoCoverUrl = this.upImgUrl;
    (this.$refs.carousel1 as any)?.setActiveItem(0);
    this.change();
    //
  }
  //上传视频
  uploadedVideo(d: any) {
    //
  }
  timeLimitGiveUpChange(value: any) {
    if (value === -1) {
      this.exam.giveUpNotSignIn = 2;
      this.exam.giveUpSignIn = 2;
    } else {
      this.exam.giveUpNotSignIn = 1;
      this.exam.giveUpSignIn = 1;
    }
  }
  giveUpSignInChange(value: number, key: string) {
    if (value !== 1) {
      this.exam[key] = 1;
    }
  }
  //获取选择的本地频播放url
  getVideoUrl(url: string) {
    // this.videoUrl = url;
    //
  }
  //上传成功后 视频id 已废弃
  setVideoId(id: string) {
    this.exam.publicityPageVideoId = id;
  }
  //上传成功后 视频url
  setVideoUrl(url: string) {
    this.exam.publicityPageVideoUrl = url;
    this.videoUrl = url;
    this.change();
  }
  //切屏
  prev(i: number) {
    (this.$refs["carousel" + i] as any)?.prev();
  }
  next(i: number) {
    (this.$refs["carousel" + i] as any)?.next();
  }
  //拖
  onMove() {
    //
  }
  //乱序起止
  setQStart() {
    const t = this.exam.questionRandomSortRange;
    if (Number(t[0]) >= Number(t[1])) {
      this.exam.questionRandomSortRange.splice(0, 1, Number(t[1]) - 1);
    }
  }
  setQEnd() {
    const t = this.exam.questionRandomSortRange;
    if (Number(t[1]) <= Number(t[0])) {
      this.exam.questionRandomSortRange.splice(1, 1, Number(t[0]) + 1);
    }
  }

  filterTime(val: any) {
    val = val.replace(/\D/g, "");
    this.exam.timeLimitExam =
      0 <= val && val < 100000 ? val : val > 99999 ? 99999 : 0;
  }
  @Emit()
  change() {
    return;
  }
  //是否条件字段
  showOp(item: any) {
    return item?.showConfigList?.[0]?.[0]?.matchParamIndex;
  }
  //条件展示文案
  showOpText(item: any) {
    const fa = this.RegisList.find((d: any) => {
      return d.paramIndex == item.showConfigList?.[0]?.[0]?.matchParamIndex;
    });
    let t = ``;
    fa?.fIdList.forEach((d: any, i: number) => {
      item.showConfigList.forEach((m: any, n: number) => {
        if (d == m[0].fId) {
          t += `[${fa.singleChoiceOptions[i]}]`;
        }
      });
    });
    return { name: fa?.name, text: t };
  }
}
